module.exports = __webpack_public_path__ + "static/poster-2-be87a619b417bfdd143a3b239f2bede7.png";